module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "bulk-product-add"
  }, [_c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('static.bulkProcessOrder.title')))]), _vm._v(" "), (!_vm.submitted) ? [(_vm.showForm) ? _c('div', {
    staticClass: "wrapper"
  }, [(_vm.submitLoading) ? _c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('p', [_vm._v("Processing Orders...")])]) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [(!_vm.loading) ? _c('v-form', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "form": _vm.form,
      "translation": "form.orderConfirm",
      "hasLabel": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "15px",
      "padding": "10px 20px"
    },
    attrs: {
      "disabled": _vm.hasNoExcise,
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.confirm')))]), _vm._v(" "), (_vm.showForm) ? _c('el-button', {
    staticClass: "small dark",
    staticStyle: {
      "margin-top": "15px",
      "padding": "10px 20px",
      "color": "#fff"
    },
    attrs: {
      "disabled": _vm.submitLoading
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.close')))]) : _vm._e()], 1)], 1), _vm._v(" "), (['confirmOrder', 'confirmOrderAndShipping'].includes(_vm.operation)) ? [(_vm.hasExciseModule) ? _c('div', [(_vm.bevearageProducts.length) ? [(_vm.hasNoExcise) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "15px",
      "display": "flex"
    },
    attrs: {
      "title": _vm.$t('static.orders.orderConfirm.exciseWarningMessage'),
      "type": "warning",
      "show-icon": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-row",
    staticStyle: {
      "border": "1px solid #ebeef5",
      "background": "#f4f3f3",
      "padding": "10px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "display": "block"
    },
    attrs: {
      "data": _vm.bevearageProducts
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.orders.orderConfirm.table.product')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.noExcise) ? _c('a', {
          on: {
            "click": function($event) {
              return _vm.quickProductEdit(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v("\n                          " + _vm._s(scope.row.name))]) : _c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3554632850)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.orders.orderConfirm.exciseCheck')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.noExcise) ? _c('i', {
          staticClass: "el-icon-circle-check success-color",
          staticStyle: {
            "font-size": "18px"
          }
        }) : _c('i', {
          staticClass: "el-icon-circle-close danger-color",
          staticStyle: {
            "font-size": "18px"
          }
        })]
      }
    }], null, false, 3082525749)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "beverage",
      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.beverage')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "packaging",
      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.packaging')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "basic",
      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.basic')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bottleVolume",
      "label": _vm.$t('static.orders.orderConfirm.table.bottleVolume')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "alcoholPercentage",
      "label": _vm.$t('static.orders.orderConfirm.table.alcoholPercentage')
    }
  })], 1)], 1)] : _vm._e()], 2) : _c('div', [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "15px",
      "display": "flex"
    },
    attrs: {
      "title": _vm.$t('static.orders.orderConfirm.upsellMessage'),
      "type": "info",
      "show-icon": ""
    }
  })], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Orders")]), _vm._v(" "), _c('el-table', {
    staticClass: "orders",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "data": _vm.orders
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.orderProducts.length) ? _c('ul', _vm._l((props.row.orderProducts), function(product) {
          return _c('li', {
            key: product.id
          }, [_c('span', {
            staticStyle: {
              "font-family": "'robotobold'"
            }
          }, [_vm._v(_vm._s(product.quantity) + " STK")]), _vm._v(" — "), _c('span', {
            staticStyle: {
              "font-family": "'robotobold'"
            }
          }, [_vm._v(_vm._s(product.name))])])
        }), 0) : _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.index.noProductFound')))])]
      }
    }], null, false, 3060253977)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "name",
      "label": _vm.$t('static.orders.table.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "status",
      "label": _vm.$t('static.orders.table.status')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "clientName",
      "label": _vm.$t('static.orders.table.clientName')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "totalValue",
      "label": _vm.$t('static.orders.table.totalValue')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "totalQuantity",
      "label": _vm.$t('static.orders.table.totalQuantity')
    }
  })], 1), _vm._v(" "), (_vm.batchProducts.length) ? [_c('p', [_vm._v("Set batch for product")]), _vm._v(" "), _c('el-table', {
    staticClass: "batchProducts",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "data": _vm.batchProducts
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('static.orders.orderConfirm.table.product')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "batchOptions"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "multiple": "",
            "placeholder": "Non-batch",
            "default-first-option": ""
          },
          on: {
            "change": function($event) {
              return _vm.updateBatchProduct(scope.row)
            }
          },
          model: {
            value: (scope.row.selectedBatch),
            callback: function($$v) {
              _vm.$set(scope.row, "selectedBatch", $$v)
            },
            expression: "scope.row.selectedBatch"
          }
        }, _vm._l((scope.row.batchOptions), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)]
      }
    }], null, false, 3138576737)
  })], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center"
    }
  }, [(!_vm.showForm) ? _c('el-button', {
    staticClass: "small dark",
    staticStyle: {
      "margin-top": "15px",
      "padding": "10px 20px"
    },
    attrs: {
      "disabled": _vm.submitLoading
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.close')))]) : _vm._e(), _vm._v(" "), (_vm.operation == 'cancelOrder') ? _c('el-button', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "15px",
      "padding": "10px 20px"
    },
    attrs: {
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.cancelOrder
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.cancelOrders')))]) : _vm._e(), _vm._v(" "), (_vm.operation == 'createInvoice') ? _c('el-button', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "15px",
      "padding": "10px 20px"
    },
    attrs: {
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.createInvoices
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.createInvoices')))]) : _vm._e()], 1)] : [_c('div', [_vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order.id
    }, [_c('p', [_vm._v("- Order " + _vm._s(order.name) + ",\n              "), (_vm.errorsByOrder[order.id] && _vm.errorsByOrder[order.id].length) ? _c('span', [_vm._v("Failed "), _c('i', {
      staticClass: "el-icon-error danger-color"
    })]) : _c('span', [_vm._v(_vm._s(_vm.successStatus) + " "), _c('i', {
      staticClass: "el-icon-success",
      staticStyle: {
        "color": "green"
      }
    })])]), _vm._v(" "), (_vm.errorsByOrder[order.id] && _vm.errorsByOrder[order.id].length) ? _c('ul', _vm._l((_vm.errorsByOrder[order.id]), function(error) {
      return _c('li', [_c('span', [_vm._v(_vm._s(error.message))])])
    }), 0) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center"
    }
  }, [(_vm.submitted) ? _c('el-button', {
    staticClass: "small dark",
    staticStyle: {
      "margin-top": "15px",
      "padding": "10px 20px"
    },
    attrs: {
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('button.close')))]) : _vm._e()], 1)], 2)]], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9bd6c76","hasScoped":false}!./src/app/components/bulkProcessOrderModal/bulkProcessOrderModal.html
// module id = 3140
// module chunks = 1